export const config = {
  CDN_URL: "https://cdn.otomat.qusotech.com/",
  API_URL: "https://api.szone.app/api/v1",
  // API_URL: "http://localhost:3320/api/v1",
  LOCAL_URL: "http://localhost:3320/api/v1",
  MAP_API_KEY: "AIzaSyCBM4uTkUhiTpZYBUFxR5NZ2ayD6S-PrmI",
};
